import React from "react";
import LicensedBook from "../book/licensed-book";
import GridView from "../../../components/gridview/GridView";
import { EDGE_SPACING, EDGE_SPACING_MED } from "./consts";
import { withAllMatches } from "../../../components/mediaquery/breakpoints";
import Action from "../../../components/batchrenderer/Action";
import PropTypes from "prop-types";

/**
 * Book grid only with responsive breakpoints
 */
function GridOnly({ BookObject = LicensedBook, isbns, tryLoadMore, label }) {
  function renderBook({ index, item, width, height }) {
    const RenderObject = item.bookObject || BookObject;
    return (
      <RenderObject
        isbn={item.isbn}
        width={width}
        height={height}
        index={index}
        context={`grid-${label}`}
      />
    );
  }

  let gridProps = {
    inset: EDGE_SPACING,
    itemsPerRow: 5,
    baseWidth: 230,
    baseHeight: 330,
    itemSpacingVert: 40,
    itemSpacingHoriz: 53
  };

  return (
    <div>
      <GridView
        items={isbns}
        renderItem={renderBook}
        {...gridProps}
        itemKeyProp="isbn"
      />
      <Action action={tryLoadMore} />
    </div>
  );
}

GridOnly.defaultProps = {
  tryLoadMore: () => {}
};

GridOnly.propTypes = {
  tryLoadMore: PropTypes.func,
  isbns: PropTypes.arrayOf(
    PropTypes.shape({
      isbn: PropTypes.string.isRequired,
      bookObject: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    })
  ).isRequired,
  BookObject: PropTypes.any
};

export default withAllMatches(GridOnly);
